import Vue from "vue";
import Vuex from "vuex";
import Q from "q";
import moment from "moment";
import routing from "./routing";
import selectCity from "./main/selectCity";

import * as getters from './getter'

const api_system_getCurrentUser = require(`@/lib/data-service/system/api_system_getCurrentUser`);
const api_system_getGlobalData = require(`@/lib/data-service/system/api_system_getGlobalData`);
const api_system_get_server_config = require(`@/lib/data-service/system/api_system_get_server_config`);

let __store;

let promise_init_global_data;
let promise_init_current_user;
let promise_init_server_config;

const init = function() {
  Vue.use(Vuex);

  __store = new Vuex.Store({
    state: {
      last_refresh_time: moment().format(`YYYY-MM-DD HH:mm:ss`),
      // click_count: cache_data.click_count,
      global_data: {},
      current_user: {},
      data_for_left_menu: {
        is_open: true,
      },
      data_for_history_tag: {
        tag_list: [],
      },
      data_for_breadcrumb: {
        entity_list: [],
      },
      ordersData: {},
      ordersNo: {},
      orderStatus: undefined,
      orderStatusText: "",
      searchForm: {},
      travelForm: {
        travelKeywords: '',
        areaType: '',
        isSpecialSupply: '',
      },
      localCity: {
        cityId: "",
        cityName: ""
      },
      baseLayout: { // 基础框架
        header: { // 头部
          localCity: { // 当前城市信息
            cityId: "",
            cityName: "",
            cityCode: ""
          }
        },

        isHeadSearch: false,
      }
    },
    getters,
    mutations: {
      update_last_refresh_time(state, pData) {
        state.last_refresh_time = pData;
      },

      update_click_count(state) {
        state.click_count += 1;
        const cache_data = cache.get();
        cache_data.click_count = state.click_count;
        cache.set({ value: cache_data });
      },

      reset_click_count(state) {
        state.click_count = 0;
        const cache_data = cache.get();
        cache_data.click_count = state.click_count;
        cache.set({ value: cache_data });
      },

      init_global_data(state) {
        promise_init_global_data = Q.when()
          .then(function() {
            return api_system_getGlobalData();
          })
          .then(function(data) {
            state.global_data = data.entity;
            global.global_data = data.entity;
          })
          .catch(function(ex) {
            console.error(ex);
            if (ex) {
              if (ex.stack) {
                console.error(ex.stack);
              }
            }
            return Q.reject(ex);
          });
      },

      init_current_user(state) {
        promise_init_current_user = Q.when()
          .then(function() {
            return api_system_getCurrentUser();
          })
          .then(function(data) {
            state.current_user = data.entity;
            global.current_user = data.entity;
          })
          .catch(function(ex) {
            console.error(ex);
            if (ex) {
              if (ex.stack) {
                console.error(ex.stack);
              }
            }
            return Q.reject(ex);
          });
      },

      init_server_config(state) {
        promise_init_server_config = Q.when()
          .then(function() {
            return api_system_get_server_config();
          })
          .then(function(data) {
            state.server_config = data.entity;
            global.server_config = data.entity;
          })
          .catch(function(ex) {
            console.error(ex);
            if (ex) {
              if (ex.stack) {
                console.error(ex.stack);
              }
            }
            return Q.reject(ex);
          });
      },

      update_localCity(state, params) {
        state.localCity = params;
      },

      update_isHeadSearch(state, isHeadSearch) {
        console.log('isHeadSearch',isHeadSearch);
        state.baseLayout.isHeadSearch = isHeadSearch;
      },

      set_base_layout(state, baseLayout) {
        state.baseLayout = baseLayout;
      },
      set_local_city(state, localCity) {
        state.baseLayout.header.localCity = localCity;
      }
    },
    modules: {
      routing,
      selectCity,
    },
  });

  // __store.commit(`init_global_data`);
  // __store.commit(`init_current_user`);
  // __store.commit(`init_server_config`);

  global.__store = __store;

  return __store;
};
init();

const update_last_refresh_time = function(pData) {
  __store.commit(`update_last_refresh_time`, pData);
};

const update_click_count = function(pData) {
  __store.commit(`update_click_count`, pData);
};

const reset_click_count = function(pData) {
  __store.commit(`reset_click_count`, pData);
};

const get_global_data = function() {
  return Q.when()
    .then(function() {
      return promise_init_global_data;
    })
    .then(function() {
      return __store.state.global_data;
    })
    .catch(function(ex) {
      console.error(ex);
      if (ex) {
        if (ex.stack) {
          console.error(ex.stack);
        }
      }
      return Q.reject(ex);
    });
};

const get_current_user = function() {
  return Q.when()
    .then(function() {
      return promise_init_current_user;
    })
    .then(function() {
      return __store.state.current_user;
    })
    .catch(function(ex) {
      console.error(ex);
      if (ex) {
        if (ex.stack) {
          console.error(ex.stack);
        }
      }
      return Q.reject(ex);
    });
};

const get_server_config = function() {
  return Q.when()
    .then(function() {
      return promise_init_server_config;
    })
    .then(function() {
      return __store.state.server_config;
    })
    .catch(function(ex) {
      console.error(ex);
      if (ex) {
        if (ex.stack) {
          console.error(ex.stack);
        }
      }
      return Q.reject(ex);
    });
};

export default __store;
